import { RootState } from "../../reducers";
import { EmotionsPredictionResult } from "./types";

export const EmotionsPredictionValueSelector = (
  state: RootState
): EmotionsPredictionResult | null =>
  state.nlp.emotionsPredictions
    ? state.nlp.emotionsPredictions.result[0].ents[0]
    : null;

export const areEmotionsPreditionsLoadingSelector = (
  state: RootState
): boolean => state.nlp.areEmotionsPreditionsLoading;
